import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { I18nPipeModule } from '../../../pipes/i18n-pipe.module';
import { FirstUpperCasePipeModule } from '../../../shared/pipes/first-uppercase-pipe.module';
import { DepartmentMultiselectComponent } from './department-multiselect.component';

@NgModule({
  declarations: [DepartmentMultiselectComponent],
  exports: [DepartmentMultiselectComponent],
  imports: [
    I18nPipeModule,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
    MatDialogModule,
    MatButtonModule,
    FirstUpperCasePipeModule,
  ],
})
export class DepartmentMultiselectModule {}
